<div class="empty-list-container">
  <mat-icon svgIcon="bringliesel-icon" class="bringliesel-icon"></mat-icon>
  <p [innerHtml]="text"></p>
</div>
